<template>
  <div>
    <AtomLoadingSecondary/>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionAcademyUsersProfile',

  created () {
    this.$router.push(`/${this.$t('rPaths.academy')}/${this.$t('mEditionMenu.academy.users.subject')}/${this.$route.params.id}/${this.$t('mEditionMenu.academy.users.children.profile.subedition')}/${this.$t('mEditionMenu.academy.users.children.profile.children.account.subitem')}`)
  }
}
</script>
